/* Beach AI PDP — buybox button fix + popup blocker + mobile variant fix (v7)

   v7 — Safari white-screen fix.
   Symptoms in Safari Web Inspector (the recurring stack we saw):
     TypeError: null is not an object (evaluating 'document.body.style')
       blockPopups (buybox-fix.js)
       MutationObserver callback
     ...repeated on every DOM mutation, plus the Noibu wrapper around
     Klaviyo's closeForms turning each throw into "Unable to process
     event: closeForms". When jm-offer renders at the 10s mark, the
     resulting mutation cascade fires this hundreds of times and Safari
     stalls the rendering thread.

   Three changes from v6:
   1. Every place we touch document.body now guards against null. This
      was the only literal exception being thrown.
   2. blockPopups is wrapped in try/catch end-to-end, so even a future
      bug can't escape into the MutationObserver task.
   3. The MutationObserver is throttled with a microtask flag — multiple
      mutations in the same tick now schedule one blockPopups, not N.
   4. Klaviyo closeForms is pushed at most once per 250ms instead of on
      every mutation, which is what was generating the Noibu "Unable to
      process event: closeForms" spam. */
(function(){
  var hoggleStyle = 'display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;align-items:center !important;justify-content:flex-start !important;gap:12px !important;width:100% !important;min-height:58px !important;height:auto !important;margin:6px 0 12px !important;padding:13px 16px !important;background:linear-gradient(180deg,#fffbeb,#fef3c7) !important;border:1.5px solid #fcd34d !important;border-radius:14px !important;color:#78350f !important;text-align:left !important;box-shadow:0 2px 10px rgba(252,211,77,.18) !important;cursor:pointer !important;overflow:hidden !important;font-family:inherit !important';
  var sgStyle = 'display:flex !important;flex-direction:row !important;align-items:center !important;justify-content:flex-start !important;gap:12px !important;width:100% !important;min-height:58px !important;height:auto !important;margin:14px 0 0 !important;padding:14px 16px !important;background:linear-gradient(135deg,#0b1220 0%,#1e293b 50%,#0b1220 100%) !important;border:1px solid rgba(99,102,241,0.4) !important;border-radius:14px !important;color:#ffffff !important;font-size:14.5px !important;font-weight:600 !important;cursor:pointer !important;text-align:left !important;box-shadow:0 4px 16px -4px rgba(99,102,241,0.4), inset 0 1px 0 rgba(255,255,255,0.06) !important;font-family:inherit !important';

  var applying = false;
  function styleAll(){
    if (applying) return;
    applying = true;
    try {
      document.querySelectorAll('.pdp__bb-makeoffer').forEach(function(btn){
        if (btn.getAttribute('style') === hoggleStyle) return;
        btn.style.cssText = hoggleStyle;
        var ico = btn.querySelector('.pdp__bb-makeoffer__ico');
        if (ico) ico.style.cssText = 'flex:0 0 28px;font-size:22px;line-height:1;display:inline-flex;align-items:center;justify-content:center;margin:0;';
        var txt = btn.querySelector('.pdp__bb-makeoffer__txt');
        if (txt) txt.style.cssText = 'flex:1 1 auto;display:flex;flex-direction:column;align-items:flex-start;text-align:left;min-width:0;line-height:1.3;font-weight:700;color:#78350f;';
        var sub = btn.querySelector('.pdp__bb-makeoffer__sub');
        if (sub) sub.style.cssText = 'font-size:11.5px;font-weight:500;color:#92400e;margin-top:2px;';
        var arr = btn.querySelector('.pdp__bb-makeoffer__arr');
        if (arr) arr.style.cssText = 'flex:0 0 auto;margin-left:auto;color:#92400e;font-size:16px;';
      });
      document.querySelectorAll('.pdp__sg-trigger--pill').forEach(function(btn){
        if (btn.getAttribute('style') === sgStyle) return;
        btn.style.cssText = sgStyle;
        var ico = btn.querySelector('.pdp__sg-trigger__ico');
        if (ico) {
          ico.style.cssText = 'flex:0 0 32px !important;width:32px !important;height:32px !important;border-radius:10px !important;background:linear-gradient(135deg,#38bdf8 0%,#6366f1 50%,#a855f7 100%) !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;font-size:0 !important;box-shadow:0 0 16px rgba(99,102,241,0.55),inset 0 0 0 1px rgba(255,255,255,0.18) !important;position:relative !important;overflow:hidden !important';
          if (!ico.querySelector('svg')) {
            ico.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M12 3l1.8 4.7L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.3L12 3z"/><path d="M19 14l.9 2.3L22 17l-2.3.9L19 20l-.9-2.1L16 17l2.1-.7L19 14z"/></svg>';
          }
        }
        var lbl = btn.querySelector('.pdp__sg-trigger__label');
        if (lbl) {
          var stray = lbl.querySelector('.pdp__sg-trigger__sub');
          if (stray) stray.remove();
          lbl.style.cssText = 'flex:1 1 auto !important;text-align:left !important;line-height:1.3 !important;color:#ffffff !important;font-weight:600 !important;font-size:14px !important;text-shadow:0 1px 8px rgba(99,102,241,0.3) !important';
        }
        var arr = btn.querySelector('.pdp__sg-trigger__arr');
        if (arr) {
          arr.style.cssText = 'flex:0 0 auto !important;margin-left:auto !important;width:28px !important;height:28px !important;border-radius:50% !important;background:linear-gradient(135deg,#38bdf8,#6366f1) !important;color:#ffffff !important;font-size:14px !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;font-weight:700 !important';
        }
      });
    } catch(e){ /* swallow — styleAll must not break the observer */ }
    finally {
      setTimeout(function(){ applying = false; }, 0);
    }
  }

  // Guard the document.body read at module load — in some edge cases
  // (early script execution, certain pixel iframes) it can be null here.
  var IS_BEACH_AI = !!(document.body && /template-product-beachcamera/.test(document.body.className || ''));

  // Klaviyo closeForms is pushed ONCE at init, and never again from the
  // mutation observer. Every push hits Noibu's wrapper, which logs an
  // error if no Klaviyo form is open — and we don't have Klaviyo forms
  // on PDPs. The accumulated error cascade is what was synchronously
  // freezing Safari when jm-offer rendered.
  var klOnsiteFired = false;
  function maybeCloseKlaviyoForms(){
    if (klOnsiteFired) return;
    klOnsiteFired = true;
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['closeForms']);
      }
    } catch(e){}
  }

  function blockPopups(){
    try {
      if (!IS_BEACH_AI) return;
      maybeCloseKlaviyoForms();
      var sels = [
        '#ju_iframe', '#justuno-iframe', '[id^="ju_"]', '[class*="justuno" i]',
        'iframe[src*="klaviyo"]', '[class*="klaviyo" i]', '[id*="klaviyo" i]', '.needsclick',
        'div[data-testid*="klaviyo" i]',
        '#attentive_overlay', '[id*="attentive" i]', '[class*="attentive" i]',
        '.popup-modal', '.email-signup-modal', '.newsletter-modal'
      ];
      sels.forEach(function(sel){
        try {
          document.querySelectorAll(sel).forEach(function(el){
            // CRITICAL: never touch body, documentElement, or any ancestor
            // of body. Some apps (Klaviyo etc.) add classes like `needsclick`
            // or `klaviyo-*` to <body> itself, which would match our popup
            // selectors. Calling .remove() on body wipes the whole page.
            if (!el || el === document.body || el === document.documentElement) return;
            if (el.contains && document.body && el.contains(document.body)) return;
            if (el.dataset.bcBlocked) return;
            el.dataset.bcBlocked = '1';
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('visibility', 'hidden', 'important');
            el.style.setProperty('pointer-events', 'none', 'important');
            try { el.remove(); } catch(e) {}
          });
        } catch(e){}
      });
      // ↓ this was the line throwing in Safari: document.body could be null
      //   during the mutation cascade. Guard it.
      var body = document.body;
      if (body && body.style && body.style.overflow === 'hidden') {
        body.style.removeProperty('overflow');
      }
    } catch(e){
      // Last-resort catch — must never let an exception escape into the
      // MutationObserver task, or Safari will keep raising it on every
      // mutation and Noibu will keep wrapping it into 'Unable to process
      // event' noise.
      try { console.warn('[buybox-fix] blockPopups swallowed:', e); } catch(_){}
    }
  }

  /* ─────────────────────────────────────────────────────────────
     MOBILE VARIANT FIX
     The mobile selector .pdp__mvar-s has option values like "Size: 55\"",
     but the underlying .pdp__variant-sel has values like "55\"".
     The section's propagation script sets desktop.value = "Size: 55\"",
     which doesn't match any option → variant change doesn't fire.
     Fix: intercept in CAPTURE phase, strip the "OptionName: " prefix,
     find the right option, and dispatch a proper change event.
     ───────────────────────────────────────────────────────────── */
  document.addEventListener('change', function(e){
    try {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.pdp__mvar-s')) return;

      var p = t.dataset.p;
      var d = p
        ? document.querySelector('.pdp__variant-sel[data-option-position="' + p + '"]')
        : document.querySelector('.pdp__variant-sel');
      if (!d) return;

      var actualValue = (t.value || '').replace(/^[^:]+:\s*/, '');

      var matchIndex = -1;
      for (var i = 0; i < d.options.length; i++) {
        if (d.options[i].value === actualValue) { matchIndex = i; break; }
      }
      if (matchIndex < 0) return;

      e.stopImmediatePropagation();

      if (d.selectedIndex !== matchIndex) {
        d.selectedIndex = matchIndex;
        d.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch(_){}
  }, true);

  // Mutation throttle — coalesce many mutations in one tick into a single
  // blockPopups+styleAll pass. Without this, jm-offer's innerHTML burst
  // (5 added nodes + their descendants) fired the observer for every
  // node, which is what amplified the underlying body-null error.
  var pending = false;
  function schedule(){
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function(){
      pending = false;
      styleAll();
      blockPopups();
    }, 0);
  }

  function init(){
    styleAll();
    blockPopups();
    // Keep a few early passes for popups that arrive before the observer
    // catches up — but go through the throttle so they coalesce.
    setTimeout(schedule, 100);
    setTimeout(schedule, 500);
    setTimeout(schedule, 1500);
    setTimeout(schedule, 3000);

    if (IS_BEACH_AI && 'MutationObserver' in window && document.body) {
      try {
        // Ignore mutations that come from our own buy-box / jm-offer.
        // The buy-box is never going to be a third-party popup, and the
        // jm-offer card renders ~12 nodes inside .pdp__buybox at the 10s
        // mark — each one was firing the observer, triggering blockPopups,
        // and accumulating noise on Safari. Skip them entirely.
        function isOurOwnMutation(target){
          if (!target || !target.closest) return false;
          return !!target.closest(
            '.pdp__buybox, [data-jm-offer], .jm-offer, .pdp__col--buy, [data-hoggle-root]'
          );
        }
        var obs = new MutationObserver(function(mutations){
          for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (!m.addedNodes || !m.addedNodes.length) continue;
            if (isOurOwnMutation(m.target)) continue;
            schedule();
            return;
          }
        });
        obs.observe(document.body, { childList: true, subtree: true });
      } catch(e){
        try { console.warn('[buybox-fix] observer setup failed:', e); } catch(_){}
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();